module.exports = __webpack_public_path__ + "static/media/haircare.879dfdc5.svg";